export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10607.b42deb41.jpg";